import type { TFunction } from 'i18next';
import { assertUnreachable } from '@levelworks/shared-utils-ts';
import { AccreditationRejectionReasonCode } from './accreditation-rejection-reasons.types';

export {
  ACCREDITATION_REJECTION_REASON_CODES,
  type AccreditationRejectionReasonCode,
} from './accreditation-rejection-reasons.types';

const HQ_SCREEN_SPECIFIC_NS = 'hq-screen-specific';

export const getRejectionReasonTranslationKey = (
  code: AccreditationRejectionReasonCode
): string => {
  switch (code) {
    case 'document_not_valid_anymore':
      // t('certificates.detail.rejection-reason.document-not-valid-anymore', { ns: 'hq-screen-specific' })
      return 'certificates.detail.rejection-reason.document-not-valid-anymore';
    case 'document_unreadable':
      // t('certificates.detail.rejection-reason.document-unreadable', { ns: 'hq-screen-specific' })
      return 'certificates.detail.rejection-reason.document-unreadable';
    case 'document_not_complete':
      // t('certificates.detail.rejection-reason.document-not-complete', { ns: 'hq-screen-specific' })
      return 'certificates.detail.rejection-reason.document-not-complete';
    case 'incorrect_certificate_type':
      // t('certificates.detail.rejection-reason.incorrect-certificate-type', { ns: 'hq-screen-specific' })
      return 'certificates.detail.rejection-reason.incorrect-certificate-type';
    default:
      return assertUnreachable(code);
  }
};

export const getRejectionReasonLabel = (
  t: TFunction,
  code: AccreditationRejectionReasonCode
): string => t(getRejectionReasonTranslationKey(code), { ns: HQ_SCREEN_SPECIFIC_NS });
